import NoGpsEvent from '@/models/NoGpsEvent'
import { PointTransformer } from '@/transformers/PointTransformer'

export class NoGpsEventTransformer {
    constructor (pointTransformer = new PointTransformer()) {
        this.pointTransformer = pointTransformer
    }

    transform (data) {
        return new NoGpsEvent(
            data.type,
            data.start,
            data.end,
            null,
            null,
            // this.pointTransformer.transform(data.startPoint),
            // this.pointTransformer.transform(data.endPoint)
        )
    }
}
